import { render, staticRenderFns } from "./LocationImages.vue?vue&type=template&id=b0dfe0b4&scoped=true"
import script from "./LocationImages.vue?vue&type=script&lang=js"
export * from "./LocationImages.vue?vue&type=script&lang=js"
import style0 from "./LocationImages.vue?vue&type=style&index=0&id=b0dfe0b4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dfe0b4",
  null
  
)

export default component.exports